
import { Col, Row } from 'antd';
import './styles.scss'
import { Container } from 'react-bootstrap';
import InputComponent from 'components/formInput/Input';
import DatePickerComponent from 'components/datepicker/Datepicker';
import Checkbox from 'antd/es/checkbox/Checkbox';
import InputAreaComponent from 'components/input-area/InputArea';
import SelectComponent from 'components/select/Select';
import ButtonComponent from 'components/button/Button';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { apiGetDetailPatient, apiPatchPatient } from 'helpers/api/master/patients';
import { useEffect, useState } from 'react';
import { ERROR_MSG, characters } from 'constants/Constants';
import { apiGetMasterArea } from 'helpers/api/master/master';
import moment from 'moment';
import { showToastError, showToastSuccess, getUserInfo } from 'utils';
import Loading from "components/loading/Loading";
import CustomInput from "components/formInput/CustomInput";
import { ROUTE } from 'routes/route';

const PatientEditPage = (initialDetails) => {
    const history = useHistory();
    const { id } = useParams();
    const userInfo = getUserInfo();
    const [isLoading, setIsLoading] = useState(false);

    const [details, setDetails] = useState(initialDetails);
    const [location, setLocations] = useState([]);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        setIsLoading(true);
        apiGetDetailPatient(id).then((resp) => {
            setIsLoading(false);
            if (resp.data) {
                setDetails(() => {
                    if (resp.data.first_name_clinic)
                        return {
                            ...resp.data,
                            treatment_start_date: resp.data.treatment_start_date_clinic || resp.data.treatment_start_date,
                            first_name_clinic: resp.data.first_name_clinic,
                            last_name_clinic: resp.data.last_name_clinic
                        }
                    else if (resp.data.first_name)
                        return {
                            ...resp.data,
                            treatment_start_date: resp.data.treatment_start_date,
                            first_name_clinic: resp.data.first_name,
                            last_name_clinic: resp.data.last_name
                        }
                    else
                        return {
                            ...resp.data,
                            treatment_start_date: '',
                            first_name_clinic: resp.data.first_name,
                            last_name_clinic: resp.data.last_name
                        }
                });
            }
        }).catch((err) => {
            console.log(err);
        })
    }, [id])

    useEffect(() => {
        apiGetMasterArea().then((resp) => {
            if (resp.data) {
                const arr = resp.data.map((item) => ({ label: item.name, value: item.id }))
                setLocations(arr);
            }
        })
    }, [])

    const { t } = useTranslation();

    const handlerChange = (e) => {
        const { name, value } = e.target;
        setDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    };

    const handlerChangeSelect = (val, name) => {
        setDetails((prevDetails) => ({
            ...prevDetails,
            [name]: val
        }));
    };

    const handlerDateChange = (date, name) => {
        setDetails((prevDetails) => ({
            ...prevDetails,
            [name]: moment((new Date(date)).toString()).format('YYYY-MM-DD'),
        }))
    }

    const validateData = () => {
        if (!details.first_name_clinic) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                first_name: ERROR_MSG.REQUIRE
            }))
            return false;
        } else if (details.first_name_clinic.length > 255) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                first_name: t("messages.MSG-USP052", { number: 255 })
            }))
            return false;
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                first_name: ''
            }))
        }

        if (!details.last_name_clinic) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                last_name: ERROR_MSG.REQUIRE
            }))
            return false;
        } else if (details.last_name_clinic.length > 255) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                last_name: t("messages.MSG-USP052", { number: 255 })
            }))
            return false;
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                last_name: ''
            }))
        }

        if (details.memo && details.memo.length > 500) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                memo: t("messages.MSG-USP052", { number: 500 })
            }))
            return false;
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                memo: ''
            }))
        }

        return true;
    }

    const handlerSubmit = (e) => {
        e.preventDefault();
        const isValid = validateData();
        if (isValid) {
            setIsLoading(true);
            apiPatchPatient(id, details).then((resp) => {
                setIsLoading(false);
                if (resp.data) {
                    showToastSuccess("messages.MSG-USP055");
                }
                history.push(ROUTE.CLINIC.PATIENT);
            }).catch((err) => {
                console.log(err);
                showToastError(err.data.error);
            })
        }
    }

    const handlerChangeCheckbox = (e) => {
        const { name, checked } = e.target
        setDetails((prevDetails) => ({
            ...prevDetails,
            [name]: checked
        }))
    }

console.log(details)
    return (
        <form onSubmit={handlerSubmit}>
            <div className="main-content">
                <div className="root-right-header">
                    <div className="screen-name">{userInfo.clinic_name || ""} 様</div>
                </div>
                <div className='nav screen-title-sub'>
                    患者情報編集
                </div>

                <Container className="patient_edit">
                    <Row>
                        <Col offset={3} md={5}>
                            <Row md={12}>
                                <Col md={24}>
                                    <InputComponent
                                        title={t('patient.edit.no')}
                                        value={details?.code}
                                        name='code'
                                        readOnly={true}
                                    />
                                </Col>
                                <Col md={3}></Col>
                            </Row>

                            <Row md={12}>
                                <Col md={11}>
                                    <InputComponent
                                        title={t('patient.edit.name')}
                                        value={details?.first_name_clinic !== undefined ? details?.first_name_clinic : details?.first_name}
                                        name='first_name_clinic'
                                        onChange={handlerChange}
                                        error={errors?.first_name ? errors?.first_name : ''}
                                    />
                                </Col>

                                <Col offset={2} md={11}>
                                    <InputComponent
                                        title={' '}
                                        value={details?.last_name_clinic !== undefined ? details?.last_name_clinic : details.last_name}
                                        name='last_name_clinic'
                                        onChange={handlerChange}
                                        error={errors?.last_name ? errors?.last_name : ''}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col md={24}>
                                    <DatePickerComponent
                                        title={t('patient.edit.dob')}
                                        value={details?.date_of_birth ? new Date(details?.date_of_birth) : ''}
                                        name="date_of_birth"
                                        onChange={(date) => handlerDateChange(date, 'date_of_birth')}
                                        customInput={<CustomInput />}
                                        maxDate={new Date()}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col md={24}>
                                    <DatePickerComponent
                                        style={{
                                            textAlight: "center"
                                        }}
                                        title={t('patient.edit.joined_date')}
                                        name="treatment_start_date"
                                        value={details.treatment_start_date ? new Date(details.treatment_start_date) : ''}
                                        onChange={(date) => handlerDateChange(date, 'treatment_start_date')}
                                        customInput={<CustomInput />}
                                    />
                                </Col>
                            </Row>

                            <Row style={{
                                marginTop: '60px'
                            }}>
                                <Checkbox name='hidden' checked={details?.hidden} onChange={handlerChangeCheckbox}>
                                    <span className='input-title-sub'>{t('patient.edit.hide')}</span>
                                </Checkbox>
                            </Row>
                        </Col>

                        <Col offset={2} md={8}>
                            <Row>
                                <InputAreaComponent
                                    rows={10}
                                    title={t('patient.edit.note')}
                                    name='memo'
                                    value={details?.memo}
                                    onChange={(val) => setDetails((prevDetails) => ({
                                        ...prevDetails,
                                        memo: val
                                    }))}
                                    error={errors?.memo ? errors?.memo : ''}
                                />
                            </Row>

                            <Row md={12}>
                                <Col md={11}>
                                    <SelectComponent
                                        title={t('patient.edit.gender')}
                                        options={[
                                            { label: '男の子', value: 'MALE' },
                                            { label: '女の子', value: 'FEMALE' }]}
                                        name='gender'
                                        value={details?.gender}
                                        onChange={(val) => handlerChangeSelect(val, 'gender')}
                                    />
                                </Col>

                                <Col offset={3} md={10}>
                                    <SelectComponent
                                        title={t('patient.edit.location')}
                                        name="area_id"
                                        options={location}
                                        value={details?.area_id}
                                        onChange={(val) => handlerChangeSelect(val, 'area_id')}
                                    />
                                </Col>
                            </Row>

                            <Row md={12}>
                                <Col md={11}>
                                    <InputComponent
                                        title={t('patient.edit.character')}
                                        readOnly={true}
                                        value={characters.find((char) => char.id === details?.character_registration)?.name}
                                        name="character_registration"
                                    />
                                </Col>
                                <Col offset={3} md={10}>
                                    <InputComponent
                                        title={t('patient.edit.last_updated')}
                                        name="last_receive_date"
                                        readOnly={true}
                                        value={details?.last_receive_date ? moment(
                                            new Date((new Date(details?.last_receive_date)).getTime() - ((new Date(details?.last_receive_date)).getTimezoneOffset() * 60 * 1000))
                                        ).format("YYYY-MM-DD HH:mm:ss") : ""}
                                    />
                                </Col>
                            </Row>

                        </Col>
                    </Row>

                    <center style={{ marginBlockStart: 75 }}>
                        <ButtonComponent
                            text="保存"
                            width={500}
                            style={{ fontSize: 20, fontWeight: 900, borderRadius: 60, marginTop: 150 }}
                            height={40}
                            type="submit"
                            onClick={handlerSubmit}
                        />
                    </center>
                </Container>
            </div>
            {isLoading && <Loading />}
        </form>
    );
}

export default PatientEditPage